/**
 * There will be one reducer file per page / common component
 */
import {
    GET_REFINEDFILTER_SUCCESS,
    GET_REFINEDFILTER_FAILURE,
    GET_REFINEDFILTER,
} from '../actions';

const initialState = {
    accountFilter: [],
    orderStatusFilter: [],
    orderTypesFilter:[],
    physicianFilter: [],
    procedureFilter: [],
    orderConditionFilter: [
        { id: 'Assigned', name: 'Assigned', selected: true },
        { id: 'Unassigned', name: 'Unassigned', selected: false },
    ],
    loading: false,
    statusCode: '',
    statusMessage: '',
};

const applyRefinedFilterData = (data) => {
    // Sort the order statuses
    if (data && data.orderStatusFilter && data.orderStatusFilter.length)
        data.orderStatusFilter = data.orderStatusFilter.sort((a, b) => {
            if (a.description.toUpperCase() > b.description.toUpperCase())
                return 1;
            if (a.description.toUpperCase() < b.description.toUpperCase())
                return -1;
            return 0;
        });
    return data
        ? data
        : {
              accountFilter: [],
              orderTypesFilter:[],
              orderStatusFilter: [],
              physicianFilter: [],
              procedureFilter: [],
          };
};

const RefinedFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REFINEDFILTER:
            return {
                ...state,
                loading: true,
            };
        case GET_REFINEDFILTER_SUCCESS:
            return {
                ...state,
                ...applyRefinedFilterData(action.data),
                loading: false,
            };
        case GET_REFINEDFILTER_FAILURE:
            return {
                ...state,
                ...initialState,
                ...action.data,
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default RefinedFilterReducer;
